import React from 'react'
import './style.css'

export function HeroPrimary({ children, className = '' }) {
  return <h1 className={`hero-primary ${className} `}>{children}</h1>
}

export function HeroPrimaryDiv({ children, className = '' }) {
  return <div className={`hero-primary ${className} `}>{children}</div>
}

export function HeroTertiary({ children, className = '' }) {
  return <h2 className={`hero-tertiary ${className}`}>{children}</h2>
}

export function Heading3({ children, className = '' }) {
  return <h3 className={`heading3 ${className}`}>{children}</h3>
}

export function CopyPrimary({ children, className = '' }) {
  return <p className={`copy-primary ${className}`}>{children}</p>
}

export function CopyPrimaryDiv({ children, className = '' }) {
  return <div className={`copy-primary ${className}`}>{children}</div>
}

export function CopySecondary({ children, className = '' }) {
  return <p className={`copy-secondary ${className}`}>{children}</p>
}

export function CopySecondaryDiv({ children, className = '' }) {
  return <div className={`copy-secondary ${className}`}>{children}</div>
}
